import * as JQ from 'jquery';

// export for others scripts to use
(window as any).$ = (window as any).jQuery = JQ.noConflict(true);
